<ion-header>
  <ion-toolbar>
    <ion-title i18n="@@sessionsDialog.pageTitle"> Робочі зміни</ion-title>
    <ion-buttons slot="end">
      <span *ngIf="loading" class="loaderd-bg"></span>
      <ion-button
        (click)="startSession()"
        *ngIf="!loading && !hasActiveSession"
        color="success"
        i18n="@@sessionsDialog.startShift"
        >Почати зміну</ion-button
      >
      <ion-button (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <table class="table">
    <tr>
      <th>#</th>
      <th i18n="@@sessionsDialog.colStatus">Статус</th>
      <th i18n="@@sessionsDialog.colStart">Початок</th>
      <th i18n="@@sessionsDialog.colClose">Закриття</th>
      <th>
        <span i18n="@@sessionsDialog.columnCash">Каса</span>
        <span style="font-size: 12px" i18n="@@sessionsDialog.columnCashHint">
          (гот/бн)</span
        >
      </th>
      <th i18n="@@sessionsDialog.colDiscount">Знижка</th>
      <th></th>
    </tr>
    <tr *ngFor="let session of userSessions; let i = index">
      <td>{{ i + 1 }}</td>
      <td>
        <span
          *ngIf="!session.end"
          class="badge badge-success"
          i18n="@@sessionsDialog.statusActive"
          >Активна</span
        >
        <span
          *ngIf="session.end"
          class="badge badge-secondary"
          i18n="@@sessionsDialog.statusClosed"
          >Закрита</span
        >
      </td>
      <td>
        {{ session.start | date : 'dd.MM HH:mm' }}
      </td>
      <td>
        <div *ngIf="!session.end">
          <button
            class="btn btn-success btn-sm"
            (click)="selectSession(session)"
            style="font-size: 12px"
            i18n="@@sessionsDialog.continue"
          >
            Продовжити
          </button>
        </div>

        {{ session.end | date : 'dd.MM HH:mm' }}
      </td>
      <td>{{ session.cash }} / {{ session.cashless }}</td>
      <td>{{ session.discount }}</td>
      <td>
        <div *ngIf="!session.end">
          <button
            class="btn btn-danger btn-sm"
            (click)="closeSession(session.id)"
            style="font-size: 12px"
            i18n="@@sessionsDialog.close"
          >
            Закрити
          </button>
        </div>
        <div *ngIf="session.end && i == 0">
          <button
            class="btn btn-warning btn-sm"
            (click)="openSession(session.id)"
            style="font-size: 12px"
            i18n="@@sessionsDialog.open"
          >
            Відкрити
          </button>
        </div>
      </td>
      <td>
        <!-- <a href="javascript:void(0)" (click)="openWorkShiftReport(session.id)">Звіт</a> -->
      </td>
    </tr>
  </table>
</ion-content>
